import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from './views/layout/Layout.vue'

Vue.use(Router)

let childrenRoutes = [
  { path: '/', component: Home, name: 'Home' },
  { path: '/about', component: () => import('./views/about/About.vue'), name: 'About' },
  { path: '/profession', component: () => import('./views/about/Profession.vue'), name: 'Profession' },
  { path: '/goods', component: () => import('./views/goods/GoodsCenter.vue'), name: 'GoodsCenter' },
  { path: '/goods-detail', component: () => import('./views/goods/GoodsDetail.vue'), name: 'GoodsDetail' },
  { path: '/qa', component: () => import('./views/qa/QA.vue'), name: 'QA' },
  { path: '/bigshot', component: () => import('./views/BigShot.vue'), name: 'BigShot' },
  { path: '/authorize-search', component: () => import('./views/authorizeSearch/AuthorizeSearch.vue'), name: 'AuthorizeSearch' },
  { path: '/cooperate', component: () => import('./views/businessCooperate/Cooperate.vue'), name: 'Cooperate' },
  { path: '/business-cooperate', component: () => import('./views/businessCooperate/BusinessCooperate.vue'), name: 'BusinessCooperate' },
  { path: '/company-newsList', component: () => import('./views/companyNews/CompanyNewsList.vue'), name: 'CompanyNewsList' },
  { path: '/company-newsDetail/:id', component: () => import('./views/companyNews/CompanyNewsDetail.vue'), name: 'CompanyNewsDetail' },
  { path: '/highFive', component: () => import('./views/readService/HighFive.vue'), name: 'HighFive' },
  { path: '/listenEnglish', component: () => import('./views/readService/ListenEnglish.vue'), name: 'ListenEnglish' },
  { path: '/talkingPen', component: () => import('./views/readService/TalkingPen.vue'), name: 'TalkingPen' },
  { path: '/recruitList', component: () => import('./views/recruit/RecruitList.vue'), name: 'RecruitList' },
  { path: '/recruitDetail', component: () => import('./views/recruit/RecruitDetail.vue'), name: 'RecruitDetail' },
]

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: childrenRoutes,
    },
    {
      path: '*', component: () => import('./views/NotFound.vue'), name: 'NotFound',
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
